module.exports = __webpack_public_path__ + "img/teresa-armstrong.1d80005a.png";